import { Navigate, useLocation } from "react-router-dom";
import { PATIENT_TEMPLATES_MACROS_PATH } from "../utils/buildPatientAuthUrl";
import { useCreReportBlocked } from "./useCreReportBlocked";

/**
 * Report page (`/patient/Study/getStudyById`): "All Public Users" are sent to
 * Templates & Macros instead — after sign-in, from a link or a bookmark
 * (Jacky 2026-11-03). Study / sign-in parameters are kept.
 */
export default function CreReportRouteGuard({ children }) {
  const blocked = useCreReportBlocked();
  const location = useLocation();
  if (blocked) {
    return <Navigate to={`${PATIENT_TEMPLATES_MACROS_PATH}${location.search}`} replace />;
  }
  return children;
}
